module.exports = __webpack_public_path__ + "static/media/Path 782.1310b20c.svg";